import { createSelector } from "reselect";
import getTopLevelChapterIds from "selectors/chapter/getTopLevelChapterIds";

const getStory = (state) => state.story;

export const getTopLevelChapterEntities = createSelector(
  getStory,
  getTopLevelChapterIds,
  (story, topLevelChapterIds) =>
    topLevelChapterIds.map(
      (chapter) => story.entities[chapter.schema][chapter.id],
    ),
);

const makeGetChapterEntities = () => getTopLevelChapterEntities;

export default makeGetChapterEntities;
